import { get } from 'lodash';

export function checkErrors(errors, fields) {
  const dataErrors = get(errors, 'meta.validationErrors', {});
  return Object.keys(dataErrors).some(r => fields.includes(r));
}



// WEBPACK FOOTER //
// ./src/components/PatientRegistration/utils/checkErrors.js